import { Props_SnippetTestimonialsCarousel } from "./TestimonialsCarousel.props"
import { useState } from "react"
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, A11y } from 'swiper/modules'
import SnippetLink from "../Shared/Link/Link"
import SwiperControls, { swiperNavigationOptions } from '../Shared/SwiperControls/SwiperControls'

const SnippetTestimonialsCarousel = (props: Props_SnippetTestimonialsCarousel) => {
    const { heading, snippet, repeatable_testimonialsCarouselOptions } = props;
    const [activeIndex, setActiveIndex] = useState(0);
    const carouselId = "testimonials-carousel";

    const backgroundColorClass = snippet.background_color?.value ? `snippet-testimonials-carousel--bg-${snippet.background_color.value}` : ''

    return (
        <section className={`snippet-testimonials-carousel ${backgroundColorClass}`}>
            <div className="snippet-testimonials-carousel__container">
                <h2 className={`snippet-testimonials-carousel__heading ${heading.visibility?.value ? '' : 'snippet-testimonials-carousel__heading--hidden'}`}>{ heading.content?.value }</h2>
                {snippet.content.value && (
                    <div className="snippet-testimonials-carousel__description">
                        <p>{snippet.content.value}</p>
                    </div>
                )}
                <Swiper
                    className="snippet-testimonials-carousel__swiper"
                    modules={[Navigation, A11y]}
                    navigation={{
                        ...swiperNavigationOptions,
                        prevEl: `.swiper-navigation__button-prev-${carouselId}`,
                        nextEl: `.swiper-navigation__button-next-${carouselId}`,
                    }}
                    loop={true}
                    centeredSlides={true}
                    watchSlidesProgress={true}
                    spaceBetween={10}
                    slidesPerView={1}
                    onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
                    breakpoints={{
                        640: {
                            slidesPerView: 1,
                        },
                        768: {
                            slidesPerView: 2,
                        },
                        1024: {
                            slidesPerView: 3,
                        },
                    }}
                >
                    {repeatable_testimonialsCarouselOptions && repeatable_testimonialsCarouselOptions.map((item, index) => (
                        <SwiperSlide key={index} className="snippet-testimonials-carousel__slide">
                            <div className={`snippet-testimonials-carousel__card${index === activeIndex ? ' snippet-testimonials-carousel__card--active' : ''}`}>
                                {item.image && (
                                    <img
                                        src={item.image.value}
                                        alt={item.imageAltText?.value || `Testimonial ${index + 1}`}
                                        className="snippet-testimonials-carousel__card-image"
                                    />
                                )}
                                <div className="snippet-testimonials-carousel__card-content">
                                    {item.title.value && (
                                        <h3 className="snippet-testimonials-carousel__card-title">{item.title.value}</h3>
                                    )}
                                    {item.content.value && (
                                        <p className="snippet-testimonials-carousel__card-description">{item.content.value}</p>
                                    )}
                                    {item.linkHref.value && (
                                        <SnippetLink
                                            url={item.linkHref.value}
                                            linkStyles={item.linkStyle?.value}
                                            openInNewTab={!!item.linkTarget?.value}
                                            className="snippet-testimonials-carousel__card-link"
                                        >
                                            {item.linkText?.value}
                                        </SnippetLink>
                                    )}
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>

                <SwiperControls 
                    uniqueId={carouselId}
                    className="snippet-testimonials-carousel__navigation"
                    showPagination={false}
                />
            </div>
        </section>
    )
}

export default SnippetTestimonialsCarousel
